var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Button, Dropdown, Search, Typography, } from "@uigovpe/components";
import { useEffect, useMemo, useRef, useState, } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getAgencies } from "../../../apis/agencies";
import { getApiErrorMessage } from "../../../apis/http";
import { getHearings, getMyHearingParticipations, } from "../../../apis/hearings";
import { getThemes } from "../../../apis/themes";
import { useAuth } from "../../auth/AuthContext";
import { HomeTabButton } from "../../layout/HomeTabButton";
import { HomeHearingCard } from "../components/HomeHearingCard";
import { goToOrLogin } from "../utils/authNavigate";
import { buildHearingApiFilters, HEARING_PAGE_SIZE, matchesHearingClientFilters, } from "../utils/filters";
var filtersCardStyle = {
    border: "2px solid #CED2D7",
    borderRadius: 12,
    display: "grid",
    gap: 16,
    padding: 16,
};
var filtersHeaderStyle = {
    alignItems: "center",
    display: "flex",
    gap: 8,
};
var filtersGridStyle = {
    display: "grid",
    gap: 16,
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
};
var filtersActionsStyle = {
    alignItems: "center",
    display: "flex",
    gap: 12,
    justifyContent: "flex-end",
};
var tabsContainerStyle = {
    alignItems: "center",
    borderBottom: "1px solid #E5E7EB",
    display: "flex",
    gap: 24,
    marginBottom: 16,
    marginTop: 16,
    width: "100%",
};
var cardsGridStyle = {
    display: "grid",
    gap: 24,
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    padding: "16px 0",
    width: "100%",
};
var emptyStateStyle = {
    color: "#6B7280",
    display: "flex",
    justifyContent: "center",
    padding: "40px 0",
    textAlign: "center",
};
var feedbackBoxBaseStyle = {
    borderRadius: 12,
    padding: "12px 16px",
};
var getPeriodRange = function (period) {
    var now = new Date();
    if (period === "Próximos 30 dias") {
        var end = new Date(now);
        end.setDate(end.getDate() + 30);
        return {
            scheduledFrom: now.toISOString(),
            scheduledTo: end.toISOString(),
        };
    }
    if (period === "Próximos 90 dias") {
        var end = new Date(now);
        end.setDate(end.getDate() + 90);
        return {
            scheduledFrom: now.toISOString(),
            scheduledTo: end.toISOString(),
        };
    }
    if (period === "Últimos 30 dias") {
        var start = new Date(now);
        start.setDate(start.getDate() - 30);
        return {
            scheduledFrom: start.toISOString(),
            scheduledTo: now.toISOString(),
        };
    }
    return {};
};
export var HearingsCatalogSection = function () {
    var navigate = useNavigate();
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var _b = useAuth(), accessToken = _b.accessToken, hasPortalConnect = _b.hasPortalConnect, hasToken = _b.hasToken, isAuthenticated = _b.isAuthenticated, login = _b.login, role = _b.role;
    var isCitizenLogged = role === "citizen";
    var debounceRef = useRef(null);
    var _c = useState(function () {
        return searchParams.get("tab") === "mine" ? "mine" : "all";
    }), tab = _c[0], setTab = _c[1];
    var _d = useState(""), search = _d[0], setSearch = _d[1];
    var _e = useState(""), debouncedSearch = _e[0], setDebouncedSearch = _e[1];
    var _f = useState("Todos"), orgao = _f[0], setOrgao = _f[1];
    var _g = useState("Todos"), tema = _g[0], setTema = _g[1];
    var _h = useState("Todos"), modality = _h[0], setModality = _h[1];
    var _j = useState("Todos"), situation = _j[0], setSituation = _j[1];
    var _k = useState("Todos"), period = _k[0], setPeriod = _k[1];
    var _l = useState(false), loading = _l[0], setLoading = _l[1];
    var _m = useState([]), hearings = _m[0], setHearings = _m[1];
    var _o = useState(new Set()), participatedIds = _o[0], setParticipatedIds = _o[1];
    var _p = useState([]), themes = _p[0], setThemes = _p[1];
    var _q = useState(false), themesLoading = _q[0], setThemesLoading = _q[1];
    var _r = useState([]), agencies = _r[0], setAgencies = _r[1];
    var _s = useState(false), agenciesLoading = _s[0], setAgenciesLoading = _s[1];
    var _t = useState(null), error = _t[0], setError = _t[1];
    var clientFilters = useMemo(function () { return ({
        agencyId: orgao === "Todos" ? "all" : orgao || "all",
        modality: modality,
        search: debouncedSearch,
        situation: situation,
        themeId: tema === "Todos" ? "all" : tema || "all",
    }); }, [debouncedSearch, modality, orgao, situation, tema]);
    var orgaosOptions = useMemo(function () { return __spreadArray([
        { code: "Todos", name: "Órgãos" }
    ], agencies.map(function (agency) { return ({
        code: agency.id,
        name: agency.acronym.substring(0, 20),
    }); }), true); }, [agencies]);
    var temasOptions = useMemo(function () { return __spreadArray([
        { code: "Todos", name: "Temas" }
    ], themes.map(function (theme) { return ({
        code: theme.id,
        name: theme.name.substring(0, 20),
    }); }), true); }, [themes]);
    var modalityOptions = useMemo(function () { return [
        { code: "Todos", name: "Tipo" },
        { code: "Presencial", name: "Presencial" },
        { code: "Online", name: "Online" },
        { code: "Híbrida", name: "Híbrida" },
    ]; }, []);
    var situationOptions = useMemo(function () { return [
        { code: "Todos", name: "Situação" },
        { code: "Em andamento", name: "Em andamento" },
        { code: "Encerrada", name: "Encerrada" },
    ]; }, []);
    var periodOptions = useMemo(function () { return [
        { code: "Todos", name: "Período" },
        { code: "Próximos 30 dias", name: "Próximos 30 dias" },
        { code: "Próximos 90 dias", name: "Próximos 90 dias" },
        { code: "Últimos 30 dias", name: "Últimos 30 dias" },
    ]; }, []);
    var canClear = search.trim().length > 0 ||
        orgao !== "Todos" ||
        tema !== "Todos" ||
        modality !== "Todos" ||
        situation !== "Todos" ||
        period !== "Todos";
    var canShowParticipationTabs = !isAuthenticated || isCitizenLogged;
    useEffect(function () {
        if (debounceRef.current) {
            window.clearTimeout(debounceRef.current);
        }
        debounceRef.current = window.setTimeout(function () {
            setDebouncedSearch(search);
        }, 300);
        return function () {
            if (debounceRef.current) {
                window.clearTimeout(debounceRef.current);
            }
        };
    }, [search]);
    useEffect(function () {
        var isMounted = true;
        var loadFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, themesResponse, agenciesResponse, loadError_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        setThemesLoading(true);
                        setAgenciesLoading(true);
                        return [4 /*yield*/, Promise.all([
                                getThemes(),
                                getAgencies({ limit: 100, page: 0 }),
                            ])];
                    case 1:
                        _a = _b.sent(), themesResponse = _a[0], agenciesResponse = _a[1];
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setThemes(themesResponse.data.themes || []);
                        setAgencies(agenciesResponse.data.agencies || []);
                        return [3 /*break*/, 4];
                    case 2:
                        loadError_1 = _b.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setError(getApiErrorMessage(loadError_1));
                        return [3 /*break*/, 4];
                    case 3:
                        if (isMounted) {
                            setThemesLoading(false);
                            setAgenciesLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        void loadFilters();
        return function () {
            isMounted = false;
        };
    }, []);
    useEffect(function () {
        if (!isCitizenLogged && tab === "mine") {
            setTab("all");
        }
    }, [isCitizenLogged, tab]);
    useEffect(function () {
        if (searchParams.get("tab") === "mine" && isCitizenLogged) {
            setTab("mine");
        }
    }, [isCitizenLogged, searchParams]);
    var selectTab = function (nextTab) {
        setTab(nextTab);
        var nextParams = new URLSearchParams(searchParams);
        if (nextTab === "mine") {
            nextParams.set("section", "hearings");
            nextParams.set("tab", "mine");
        }
        else {
            nextParams.delete("tab");
        }
        setSearchParams(nextParams, { replace: true });
    };
    useEffect(function () {
        if (!accessToken) {
            setParticipatedIds(new Set());
            return;
        }
        var isMounted = true;
        var loadParticipations = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getMyHearingParticipations(accessToken)];
                    case 1:
                        response = _b.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setParticipatedIds(new Set((response.data.participations || []).map(function (entry) { return entry.hearingId; })));
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        if (isMounted) {
                            setParticipatedIds(new Set());
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        void loadParticipations();
    }, [accessToken]);
    useEffect(function () {
        var isMounted = true;
        var fetchHearings = function () { return __awaiter(void 0, void 0, void 0, function () {
            var collected, page, total, response, batch, loadError_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setLoading(true);
                        setError(null);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, 6, 7]);
                        collected = [];
                        page = 0;
                        total = Number.POSITIVE_INFINITY;
                        _c.label = 2;
                    case 2:
                        if (!(collected.length < total)) return [3 /*break*/, 4];
                        return [4 /*yield*/, getHearings(buildHearingApiFilters(clientFilters, page, HEARING_PAGE_SIZE), accessToken)];
                    case 3:
                        response = _c.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        batch = response.data.publicHearings || [];
                        collected.push.apply(collected, batch);
                        total = (_b = (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.total) !== null && _b !== void 0 ? _b : collected.length;
                        if (batch.length === 0 || batch.length < HEARING_PAGE_SIZE) {
                            return [3 /*break*/, 4];
                        }
                        page += 1;
                        if (page > 100) {
                            return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 2];
                    case 4:
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setHearings(collected);
                        return [3 /*break*/, 7];
                    case 5:
                        loadError_2 = _c.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setError(getApiErrorMessage(loadError_2));
                        return [3 /*break*/, 7];
                    case 6:
                        if (isMounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        void fetchHearings();
    }, [accessToken, clientFilters]);
    useEffect(function () {
        if (!canShowParticipationTabs && tab === "mine") {
            setTab("all");
        }
    }, [canShowParticipationTabs, tab]);
    var listToRender = useMemo(function () {
        var periodRange = getPeriodRange(period);
        var filtered = hearings.filter(function (hearing) {
            return matchesHearingClientFilters(hearing, clientFilters, periodRange);
        });
        if (tab === "mine") {
            return filtered.filter(function (hearing) { return participatedIds.has(hearing.id); });
        }
        return filtered;
    }, [clientFilters, hearings, participatedIds, period, tab]);
    var resultsLabel = listToRender.length === 0
        ? "Nenhum resultado"
        : "".concat(listToRender.length, " resultado").concat(listToRender.length > 1 ? "s" : "");
    var clearAll = function () {
        setSearch("");
        setOrgao("Todos");
        setTema("Todos");
        setModality("Todos");
        setSituation("Todos");
        setPeriod("Todos");
    };
    var requireLoginForMine = function () {
        goToOrLogin({
            hasPortalConnect: hasPortalConnect,
            hasToken: hasToken,
            isAuthenticated: isAuthenticated,
            login: login,
            navigate: navigate,
            path: "/?section=hearings&tab=mine",
        });
    };
    var renderFeedback = function () {
        if (error) {
            return (_jsx("div", __assign({ style: __assign(__assign({}, feedbackBoxBaseStyle), { background: "#FFE4E4", color: "#7A1F1F" }) }, { children: _jsx(Typography, { children: error }) })));
        }
        if (!loading && listToRender.length === 0) {
            return (_jsx("div", __assign({ style: emptyStateStyle }, { children: _jsx(Typography, { children: tab === "mine" && isCitizenLogged
                        ? "Você ainda não possui participações em audiências."
                        : "Nada encontrado com os filtros atuais." }) })));
        }
        if (loading) {
            return (_jsx("div", __assign({ style: emptyStateStyle }, { children: _jsx(Typography, { children: "Carregando..." }) })));
        }
        return null;
    };
    var feedback = renderFeedback();
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: filtersCardStyle }, { children: [_jsxs("div", __assign({ style: filtersHeaderStyle }, { children: [_jsx(FilterAltOutlinedIcon, { htmlColor: "#28272C" }), _jsx(Typography, __assign({ fontWeight: "bold" }, { children: "Filtrar audi\u00EAncias" }))] })), _jsxs("div", __assign({ style: filtersGridStyle }, { children: [_jsx(Search, { label: "", onChange: function (event) { var _a, _b; return setSearch((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ""); }, placeholder: "Buscar por t\u00EDtulo", showAutocomplete: false, value: search }), _jsx(Dropdown, { className: "w-full", disabled: agenciesLoading, onChange: function (event) { var _a; return setOrgao((_a = event.value) !== null && _a !== void 0 ? _a : "Todos"); }, optionLabel: "name", optionValue: "code", options: orgaosOptions, placeholder: agenciesLoading ? "Carregando..." : "Órgão", value: orgao }), _jsx(Dropdown, { className: "w-full", disabled: themesLoading, onChange: function (event) { var _a; return setTema((_a = event.value) !== null && _a !== void 0 ? _a : "Todos"); }, optionLabel: "name", optionValue: "code", options: temasOptions, placeholder: themesLoading ? "Carregando..." : "Tema", value: tema }), _jsx(Dropdown, { className: "w-full", onChange: function (event) {
                                    var _a;
                                    return setModality((_a = event.value) !== null && _a !== void 0 ? _a : "Todos");
                                }, optionLabel: "name", optionValue: "code", options: modalityOptions, placeholder: "Tipo", value: modality }), _jsx(Dropdown, { className: "w-full", onChange: function (event) {
                                    var _a;
                                    return setSituation((_a = event.value) !== null && _a !== void 0 ? _a : "Todos");
                                }, optionLabel: "name", optionValue: "code", options: situationOptions, placeholder: "Situa\u00E7\u00E3o", value: situation }), _jsx(Dropdown, { className: "w-full", onChange: function (event) {
                                    var _a;
                                    return setPeriod((_a = event.value) !== null && _a !== void 0 ? _a : "Todos");
                                }, optionLabel: "name", optionValue: "code", options: periodOptions, placeholder: "Per\u00EDodo", value: period })] })), _jsxs("div", __assign({ style: filtersActionsStyle }, { children: [_jsx(Typography, __assign({ size: "xs" }, { children: loading || agenciesLoading || themesLoading
                                    ? "Carregando..."
                                    : resultsLabel })), _jsx(Button, { disabled: !canClear, label: "Limpar Filtros", link: true, onClick: clearAll, style: { fontSize: 12 } })] }))] })), canShowParticipationTabs ? (_jsxs("div", __assign({ style: tabsContainerStyle }, { children: [_jsx(HomeTabButton, { active: tab === "all", label: "Todas as audi\u00EAncias", onClick: function () { return selectTab("all"); } }), _jsx(HomeTabButton, { active: tab === "mine", label: "Minhas contribui\u00E7\u00F5es", onClick: function () {
                            if (!isAuthenticated || !isCitizenLogged) {
                                requireLoginForMine();
                                return;
                            }
                            selectTab("mine");
                        } })] }))) : null, feedback ? (feedback) : (_jsx("div", __assign({ style: cardsGridStyle }, { children: listToRender.map(function (hearing) { return (_jsx(HomeHearingCard, { hearing: hearing }, hearing.id)); }) })))] }));
};
